import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { useStatsig } from '../hooks/useStatsig';
import { showSplash } from '../../actions/splash-actions';

const StatsigLink = ({ gate, enabledTo, disabledTo, children, ...rest }) => {
  const { checkGate } = useStatsig();
  const dispatch = useDispatch();
  const isEnabled = checkGate(gate);

  if (isEnabled) {
    dispatch(showSplash);
    return <a href={enabledTo} {...rest}>{children}</a>;
  }

  return <Link to={disabledTo} {...rest}>{children}</Link>;
};

export default StatsigLink;
